<template>
  <div class="modal-callback d-flex flex-column justify-content-center align-items-center">
    <div class="close-btn" @click="$root.hideCallback()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
      >
        <path
          d="M20 2.60225L18.2611 0.874268L10 9.0834L1.73892 0.874268L0 2.60225L8.26108 10.8114L0 19.0205L1.73892 20.7485L10 12.5394L18.2611 20.7485L20 19.0205L11.7389 10.8114L20 2.60225Z"
          fill="#000000"
        />
      </svg>
    </div>
    <h2 class="ttl">Задать вопрос</h2>
    <div class="modal-form">
      <b-form-group
        class="d-flex align-items-end"
        label="ФИО*"
        label-for="input-fio"
        id="input-fio-group"
      >
        <b-form-input
          oninput="this.value = this.value.replace(/[^ \a-zA-Zа-яA-Я]/g, '')"
          id="input-fio"
          v-model.trim="fio"
          placeholder="Введите имя*"
          @input="$v.fio.$touch()"
          @blur="checkError($v.fio, 'fio')"
          @focus="$v.fio.$touch()"
          autocomplete="off"
        ></b-form-input>
        <div class="error-pop" v-if="fioError !== ''">{{fioError}}</div>
      </b-form-group>
      <b-form-group class="d-flex align-items-end" label="Телефон*" label-for="input-tel">
        <b-form-input
          autocomplete="off"
          placeholder="+7("
          id="input-tel"
          v-model.trim="tel"
          @input="$v.tel.$touch()"
          @focus="$v.tel.$touch()"
          @blur="checkError($v.tel, 'tel')"
        ></b-form-input>
        <div class="error-pop" v-if="telError !== ''">{{telError}}</div>
      </b-form-group>
      <div class="textarea-container">
        <label for="comment">ВАШ ВОПРОС</label>
        <resizable-textarea>
          <textarea
            v-model.trim="textarea"
            class="textarea-container-item outline-0 w-100"
            id="comment"
            name="input[comment]"
            rows="4"
          ></textarea>
        </resizable-textarea>
      </div>
      <button class="modal-button" @click="formSend()" :disabled="btndisable">Оставить заявку</button>
      <div class="modal-confident">
        <p>
          Нажимая на кнопку, Вы соглашаетесь
          с
          <a
            :href="$root.politconf"
            target="_blank"
          >политикой конфиденциальности</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Inputmask from "inputmask";
import { required, minLength } from "vuelidate/lib/validators";

const axios = require("axios");
export default {
  data() {
    return {
      fio: "",
      tel: "+7(",
      fioError: "",
      telError: "",
      visible: false,
      textarea: ""
    };
  },
  mounted() {
    var im = new Inputmask("+7(999)999-99-99", {
      positionCaretOnClick: "radixFocus",
      placeholder: "",
      greedy: false
    });
    im.mask(document.getElementById("input-tel"));
  },
  validations: {
    fio: {
      required,
      minLength: minLength(4)
    },
    tel: {
      required,
      minLength: minLength(16)
    }
  },
  methods: {
    checkError(err, name) {
      if (err.$error) {
        switch (name) {
          case "fio":
            if (!err.required) {
              this.fioError = "Это поле должно быть обязательно";
            } else if (!err.minLength) {
              this.fioError = "Это поле не должно быть короче 4 символов";
            }
            break;
          case "tel":
            if (!err.required) {
              this.telError = "Это поле должно быть обязательно";
            } else if (!err.minLength) {
              this.telError = "Введите номер в формате +7(ххх)ххх-хх-хх";
            }
            break;
        }
      } else {
        switch (name) {
          case "fio":
            this.fioError = "";
            break;
          case "tel":
            this.telError = "";
            break;
        }
      }
    },
    toggle() {
      this.visible = !this.visible;
      this.error1 = false;
      this.error2 = false;
      this.error3 = false;
    },
    select(option) {
      this.value = option;
    },
    formSend() {
      let this_comp = this;
      const formData = new FormData();
      formData.append("act", "modal-callback");
      formData.append("fio", this.fio);
      formData.append("phone", this.tel);
      formData.append("comment", this.textarea);

      axios
        .post(`${this_comp.$root.routLink}/ajax/?ajax&act=form`, formData)
        .then(function(response) {
          this_comp.$root.showSuc();
          this_comp.$root.hideCallback();
          this_comp.fio = "";
          this_comp.phone = "+7(";
        })
        .catch(function(error) {})
        .finally(function() {});
    }
  },
  computed: {
    btndisable() {
      if (this.fioError !== "" || this.telError !== "") {
        return true;
      }
      return false;
    }
  },
  watch: {
    fio: function(val) {
      this.fio = val.replace(/[^ \a-zA-Zа-яA-Я]/g, "");
    }
  }
};
</script>

<style lang="scss">
.modal-callback {
  background-color: $defaultColor;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0 75px;
  height: 533px;
  @media only screen and (max-width: $sm),
    only screen and (max-device-width: $sm) {
    padding: 0 15px;
  }

  .ttl {
    font-weight: 700;
    font-size: 30px;
    line-height: 115%;
    color: $mainFontColor;
    margin-bottom: 25px;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
    }
  }

  .modal-form {
    .form-group {
      width: 100%;
      height: 50px;
      position: relative;
      border: 1px solid #cccccc;
      border-radius: 6px;
      margin-bottom: 10px;
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
        margin-bottom: 10px;
      }

      label {
        position: absolute;
        top: 10px;
        left: 10px;
        font-weight: 600;
        font-size: 10px;
        text-transform: uppercase;
        color: #cccccc;
        line-height: 1;
      }

      div:not(.error-pop) {
        width: 100%;
        height: calc(100% - 25px);

        input {
          width: 100%;
          height: 100%;
          background-color: transparent;
          border: none;
          font-weight: 500;
          font-size: 12px;
          line-height: 1;
          color: #000000;
          padding-top: 0;
          padding-bottom: 10px;

          &:focus {
            outline: none;
            box-shadow: none;
          }

          &::-webkit-input-placeholder {
            font-weight: 500;
            font-size: 12px;
            line-height: 100%;
            color: #000000;
          }
        }
      }

      .error-pop {
        background: #ffffff;
        filter: drop-shadow(0px 0px 4px #cccccc);
        border-radius: 6px;
        height: 56px;
        padding: 0px 11px;
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        transform: translateY(-100%);
        font-weight: 600;
        font-size: 12px;
        line-height: 100%;
        color: #8b5253;

        &::after {
          content: url("data:image/svg+xml;charset=utf8,%3Csvg width='17' height='12' viewBox='0 0 17 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.5 11.9999L0.272759 0.749939L16.7272 0.749939L8.5 11.9999Z' fill='white'/%3E%3C/svg%3E");
          position: absolute;
          bottom: -13px;
        }
      }
    }

    .modal-button {
      width: 100%;
      height: 45px;
      border-radius: 6px;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: $defaultColor;
      border: 2px solid $activeColor;
      background-color: $activeColor;
      outline: none;
      transition: all 0.5s ease-in-out;

      &[disabled] {
        background: #d3a9a7;
        border-radius: 6px;
        color: #8b5253;
        border: 2px solid #d3a9a7;
      }

      @media only screen and (max-width: $md),
        only screen and (max-device-width: $md) {
        width: 100%;
        margin-bottom: 10px;
      }

      &:not([disabled]):hover {
        background-color: $activeColor;
        color: #ffffff;
      }
    }

    .modal-confident {
      height: 45px;
      width: 100%;
      font-weight: 500;
      font-size: 12px;
      line-height: 138%;
      display: flex;
      align-items: center;
      color: #7b7b7b;

      p {
        @media only screen and (max-width: $md),
          only screen and (max-device-width: $md) {
          text-align: center;
          height: 100%;
        }
      }

      a {
        color: #7b7b7b;
        text-decoration: underline;
      }
    }
  }

  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .textarea-container {
    position: relative;
    border: 1px solid #cccccc;
    box-sizing: border-box;
    border-radius: 6px;
    background-color: transparent;
    padding: 25px 10px 10px 8px;
    margin-bottom: 5px;
    max-height: 200px;
    overflow-y: scroll;
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
      margin-bottom: 10px;
    }

    label {
      position: absolute;
      top: 10px;
      left: 10px;
      font-weight: 600;
      font-size: 10px;
      line-height: 100%;
      text-transform: uppercase;
      color: #cccccc;
    }

    &-item {
      background-color: transparent;
      border: none;
      font-weight: 500;
      font-size: 12px;
      line-height: 100%;
      color: $mainFontColor;

      &::-webkit-input-placeholder {
        font-weight: 500;
        font-size: 12px;
        line-height: 100%;
        color: $mainFontColor;
      }
    }
  }
}
</style>

// <style lang="scss">
// .modal-callback {
//   .error-pop {
//     background: #ffffff;
//     border: 1px solid #cccccc;
//     border-radius: 6px;
//     height: 56px;
//     padding: 0px 11px;
//     display: flex;
//     align-items: center;
//     position: absolute;
//     top: 0;
//     left: 0;
//     transform: translateY(-100%);
//     font-weight: 600;
//     font-size: 12px;
//     line-height: 100%;
//     color: #8b5253;

//     &::after {
//       content: url("data:image/svg+xml;charset=utf8,%3Csvg width='17' height='12' viewBox='0 0 17 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.5 11.9999L0.272759 0.749939L16.7272 0.749939L8.5 11.9999Z' fill='white' /%3E%3C/svg%3E");
//       position: absolute;
//       bottom: -13px;
//     }
//   }
// }
//
</style>